export const formatPercent = (n?: number) => (n ? n * 100 : undefined);
